module.exports = __webpack_public_path__ + "img/smf_quiz_night_creation.edeb693c.png";